import { render, staticRenderFns } from "./CaSuv.vue?vue&type=template&id=067b5e95&scoped=true&"
import script from "./CaSuv.vue?vue&type=script&lang=js&"
export * from "./CaSuv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067b5e95",
  null
  
)

export default component.exports